<template>
  <vxe-table-colgroup v-if="col.children && col.children.length" v-bind="col">
    <vxe-table-column-render v-for="(ccol,index) in col.children" :key="index" :col="ccol" />
  </vxe-table-colgroup>
  <vxe-table-column v-else v-bind="col"></vxe-table-column>
</template>
<script>
import VxeTableColumnRender from './VxeTableColumnRender';
export default {
  props: ['col'],
  components: { VxeTableColumnRender: VxeTableColumnRender },
}
</script>